import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

// @author: Akashata [Backend Team]
// First %s is Txn Id
// Second %s is True or False to call verify txn
// BS_AA_ReturnUrlWeb: https://portal-qa.fibe.in/bank-statement?trans=%s/%s
// BS_AA_ReturnUrlGoogleSpot: https://portal-qa.fibe.in/bank-statement?trans=%s/%s
// BS_AA_ReturnUrlPortal: https://portal-qa.fibe.in/bank-statement?trans=%s/%s
// if Second %s => true, call verifytxn
// if not then goes back to previous screen

/**
 * @author Akashata
 */
export const LMT_ENHCMT_bsVerifyTxn_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_bsVerifyTxn_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LMT_ENHCMT_bsVerifyTxn_API_CALL/pending', payload: {} });
    const { requestBody, successFn, errorFn } = payload;
    const { esTransactionId, authorization, customerId } = requestBody;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'perfiosforweb',
      payload: {
        // customerRefNum: "27599626lqzbis",
        journeyType: 'LIMIT_ENHANCE',
        customerId,
        requestType: 'BS_VERIFY_TXN',
        esTransactionId,
        // perfiosTransactionId: "XYZ"
      },
      otherPayloadDetailsPresent: true,
      headers: { authorization, customerid: customerId },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const bsVerifyTxnResponse = res;
        if (successFn) successFn(bsVerifyTxnResponse);
        dispatch({
          type: 'LMT_ENHCMT_bsVerifyTxn_API_CALL/fulfilled',
          payload: bsVerifyTxnResponse,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        if (errorFn) errorFn(err);
        dispatch({
          type: 'LMT_ENHCMT_bsVerifyTxn_API_CALL/rejected',
          payload: err,
        });
      },
    });
  }
);

export const LMT_ENHCMT_bsVerifyTxn_API_CALL_extrareducer = {
  [LMT_ENHCMT_bsVerifyTxn_API_CALL.pending]: (state, action) => {
    state.bsVerifyTxnAPICall.isLoading = true;
  },
  [LMT_ENHCMT_bsVerifyTxn_API_CALL.fulfilled]: (state, action) => {
    state.bsVerifyTxnAPICall.isLoading = false;
    state.bsVerifyTxnAPICall.isSuccess = true;
    state.bsVerifyTxnAPICall.isError = false;
    state.bsVerifyTxnAPICall.response = action.payload;
  },
  [LMT_ENHCMT_bsVerifyTxn_API_CALL.rejected]: (state, action) => {
    state.bsVerifyTxnAPICall.isLoading = false;
    state.bsVerifyTxnAPICall.isSuccess = false;
    state.bsVerifyTxnAPICall.isError = true;
    state.bsVerifyTxnAPICall.response = action.payload;
  },
};
